/* MYMALDO - Wisch-Punkte + Warenkorb-Extras */
(function () {
  'use strict';
  var SELECTORS = ['.gallery__track', '.features', '.steps', '.quotes', '.contents__track'];
  function buildDots(track) {
    if (track.__dots) return;
    var items = Array.prototype.filter.call(track.children, function (c) { return c.nodeType === 1; });
    if (items.length < 2) return;
    if (track.scrollWidth <= track.clientWidth + 8) return;
    var wrap = document.createElement('div');
    wrap.className = 'swipe-ui';
    var dots = document.createElement('div');
    dots.className = 'swipe-dots';
    items.forEach(function (it, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Bild ' + (i + 1));
      b.addEventListener('click', function () {
        track.scrollTo({ left: it.offsetLeft - items[0].offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });
    var hint = document.createElement('span');
    hint.className = 'swipe-hint';
    hint.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg> Wischen';
    wrap.appendChild(dots);
    wrap.appendChild(hint);
    track.parentNode.insertBefore(wrap, track.nextSibling);
    track.__dots = true;
    function update() {
      var step = items.length > 1 ? (items[1].offsetLeft - items[0].offsetLeft) : track.clientWidth;
      var idx = Math.round(track.scrollLeft / Math.max(step, 1));
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) idx = items.length - 1;
      Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === idx); });
      if (idx > 0) hint.classList.add('is-hidden');
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    update();
  }
  function initDots() {
    SELECTORS.forEach(function (sel) { document.querySelectorAll(sel).forEach(buildDots); });
  }
  function cartUrl(p) { return ((window.theme && window.theme.routes && window.theme.routes[p]) || ''); }
  function syncUpsell() {
    var box = document.querySelector('[data-upsell]');
    if (!box) return;
    fetch(cartUrl('cartJs') || '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = {};
        cart.items.forEach(function (it) { inCart[it.variant_id] = true; });
        var visible = 0;
        var hiddenMore = 0;
        box.querySelectorAll('[data-upsell-item]').forEach(function (el) {
          var hide = !!inCart[el.getAttribute('data-variant')];
          el.hidden = hide;
          if (!hide) { visible++; if (el.classList.contains('upsell--more')) hiddenMore++; }
        });
        var mb = box.querySelector('[data-upsell-more]');
        if (mb && !box.classList.contains('is-expanded')) mb.hidden = hiddenMore === 0;
        box.hidden = cart.item_count === 0 || visible === 0;
      }).catch(function () {});
  }
  function initUpsell() {
    var box = document.querySelector('[data-upsell]');
    if (!box) return;
    box.addEventListener('click', function (e) {
      var more = e.target.closest('[data-upsell-more]');
      if (more) { box.classList.add('is-expanded'); more.hidden = true; return; }
      var btn = e.target.closest('[data-upsell-add]');
      if (!btn) return;
      btn.disabled = true; btn.classList.add('is-loading');
      fetch(cartUrl('cartAdd') || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-upsell-add'), 10), quantity: 1 }] })
      }).then(function () {
        var opener = document.querySelector('[data-cart-open]');
        if (opener) opener.click();
      }).finally(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
    });
    var lines = document.querySelector('[data-cart-lines]');
    if (lines && 'MutationObserver' in window) {
      new MutationObserver(function () { syncUpsell(); }).observe(lines, { childList: true });
    }
    syncUpsell();
  }
  document.addEventListener('DOMContentLoaded', function () {
    initUpsell();
    initDots();
    window.addEventListener('load', initDots);
    window.addEventListener('resize', initDots);
  });
})();
